import React, { useState, useEffect } from 'react';
import AuthContext from './AuthContext';

const AuthContextProvider = ({ children }) => {
  const [loginDetails, setLoginDetails] = useState({
    isAuthenticated: !!localStorage.getItem('linkedin_token')
  });

  // Sync state with local storage when token changes
  useEffect(() => {
    const token = localStorage.getItem('linkedin_token');
    setLoginDetails({ isAuthenticated: !!token });
  }, []);

  return <AuthContext.Provider value={{ loginDetails, setLoginDetails }}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
